module.exports = "pegasus_template/assets/blocks/column-3-theme4.png";